import { Component } from "@angular/core";
import { airQuoteFormService } from "../airQuoteForm/airQuoteForm.service";
import { ToastsManager } from "ng2-toastr/ng2-toastr";
import { FormBuilder, Validators, FormGroup, FormControl } from "@angular/forms";
import { Constants } from "../constants/constants";
import { ActivatedRoute, Router } from "@angular/router";
import { QuoteStatuses, FormType } from "../enums/enums";
import { airQuoteHistoryService } from "../airQuoteHistory/airQuoteHistory.service";

@Component({
    selector: "airQuoteForm",
    templateUrl: "/app/airQuoteForm/airQuoteForm.template.html",
    providers: [airQuoteFormService, airQuoteHistoryService]
})
export class AirQuoteFormComponent {
    quoteForm = {} as IAirQuoteFormModel;
    selectedShipMethod: IAirQuoteShipMethodModel = null;
    itemToAdd = {} as IAirQuoteItemModel;
    items = [] as Array<IAirQuoteItemModel>;
    itemsFormGroup: FormGroup;
    quoteFormGroup: FormGroup;
    quote = {} as IAirQuoteModel;
    quoteId = 0;
    editPurchase: IAirQuoteApproverModel;
    editRequiredDate: Date;
    currentDate = new Date().toLocaleString();
    ownsPurchase = false;
    submitting = false;
    currType: string;   
    requestedBy: string;

    quotesFormGroup: FormGroup;
    quoteDetailToAdd = {} as IAirQuoteDetails;
    quoteDetails = [] as Array<IAirQuoteDetails>;
    attachments = [] as Array<File>;

    selectedReason: IAirQuoteReasonCodeModel = null;
    reasonCode: number;

    selectedShipLocation: IAirQuoteShipLocationModel = null;
    shipLocation: number;   

    shipStreet: string;
    shipCity: string;
    shipState: string;
    shipZipcode: string;

    constructor(private quoteFormService: airQuoteFormService, private toast: ToastsManager, private formBuilder: FormBuilder, private constants: Constants, private activatedRoute: ActivatedRoute, private quoteHistoryService: airQuoteHistoryService, private router: Router) { }

    ngOnInit() {
        this.quoteId = this.activatedRoute.snapshot.params["quoteId"] ? this.activatedRoute.snapshot.params["quoteId"] : 0;       
        this.quote.items = [];
        this.quote.attachments = [];
        this.buildValidationGroups();
        this.quote.quoteDetails = [];

        this.shipStreet = "";
        this.shipCity = "";
        this.shipState = "";
        this.shipZipcode = "";

        this.quoteFormService.getQuoteForm().subscribe((quoteForm: IAirQuoteFormModel): void => {            
            if (quoteForm) {
                this.quoteForm = quoteForm; 
                if (this.quoteId > 0) {                    
                    this.quoteHistoryService.getQuoteById(this.quoteId).subscribe((result: IAirQuoteHistoryModel): void => {                           
                        this.setupEdit(result);
                    });
                } else {
                    this.ownsPurchase = true;
                    this.quote.firstName = this.constants.user.firstName;
                    this.quote.lastName = this.constants.user.lastName;
                }
            }
        });
    }

    setupEdit(quote: IAirQuoteHistoryModel) {
        
        this.ownsPurchase = quote.username === this.constants.user.username;
        this.quote.PurchaserId = quote.PurchaserId;
        this.quote.id = quote.id;
        this.quote.username = quote.username;
        this.quote.comment = quote.comment;
        this.quote.created = quote.created;
        this.quote.firstName = quote.firstName;
        this.quote.lastName = quote.lastName;
        this.quote.formStatusId = quote.formStatusId;
        this.quote.items = quote.items;
        this.quote.quoteDetails = quote.quoteDetails;
        this.quote.title = quote.title;
        this.quote.reasonCode = quote.reasonCode;
        this.quote.trackingInfo = quote.trackingInfo;
        this.quote.managerName = quote.managerName;
        this.quote.quoteApproverID = quote.quoteApproverID;
        this.quote.attachments = quote.attachments;
        this.quote.shipLocationId = quote.shipLocationId
        
        this.quote.quoteDetails = quote.quoteDetails;        

        this.selectedReason = this.quoteForm.reasonCodes.find((reasonCode: IAirQuoteReasonCodeModel) => reasonCode.id === quote.reasonCode);
        this.selectedShipLocation = this.quoteForm.shipLocations.find((shipLocation: IAirQuoteShipLocationModel) => shipLocation.id === quote.shipLocationId);
        this.shipStreet = this.selectedShipLocation.street;
        this.shipCity = this.selectedShipLocation.city;
        this.shipState = this.selectedShipLocation.state;
        this.shipZipcode = this.selectedShipLocation.zipcode;
        this.items = quote.items;
        
    }    

    addItem(): void {
        if (!this.itemsFormGroup.valid)
            return;

        let item = <IAirQuoteItemModel>
            {
                id: 0,
                quoteId: this.itemToAdd.quoteId,
                itemDescription: this.itemToAdd.itemDescription,
                itemCode: this.itemToAdd.itemCode,
                quantity: this.itemToAdd.quantity,
                poNumber: this.itemToAdd.poNumber,
                trackingInfo: this.itemToAdd.trackingInfo,
                quoteDetails: this.itemToAdd.quoteDetails,
                manufacturer: this.itemToAdd.manufacturer,
            };

        this.items.push(item);

        this.itemToAdd.itemDescription = "";
        this.itemToAdd.itemCode = "";
        this.itemToAdd.poNumber = "";
        this.itemToAdd.quantity = null;
        this.itemToAdd.manufacturer = "";
    }

    removeItem(item: IAirQuoteItemModel): void {
        this.items.splice(this.items.indexOf(item), 1);
    }

    buildValidationGroups(): void {
        this.itemsFormGroup = this.formBuilder.group({
            quantity: [1, [this.checkGreaterThanZero, Validators.required]],
            part: ["", [Validators.required]],
            description: ["", [Validators.required]],
            poNumber: "",
            manufacturer: ["", [Validators.required]]
        });

        this.quoteFormGroup = this.formBuilder.group({
            title: ["", [Validators.required]],            
            selectedReasonCodeType: [null, [Validators.required]],
            trackingInfo: "",
            selectedShipLocationCode: [null, [Validators.required]],
            domesticOvernight: false,
            fedExInternationalPriority: false,
            fedExInternationalEconomy: false,
            ftnAir: false,
            ocean: false,
            other: false
        },
            {
                validator: this.checkItems.bind(this)
            });

        this.quotesFormGroup = this.formBuilder.group({
            id: 0,
            quoteId: 0,
            method: [null, [Validators.required]],
            cost: ["", [Validators.required]],                           
            trackingNum: "",
            selected:false            
        });
    }

    addQuote(): void {
        if (!this.quotesFormGroup.valid)
            return;        
        let quoteDetailToAdd = <IAirQuoteDetails>
            {
                id: 0,
                quoteId: 0,
                method: this.selectedShipMethod.name,
                cost: this.quoteDetailToAdd.cost,                            
                trackingNum: this.quoteDetailToAdd.trackingNum,
                selected: this.quoteDetailToAdd.selected                
            };

        this.quote.quoteDetails.push(quoteDetailToAdd);

        this.selectedShipMethod = null;
        this.quoteDetailToAdd.cost = null;              
        this.quoteDetailToAdd.trackingNum = "";        
        
    }
    removeQuote(quote: IAirQuoteDetails): void {
        this.quote.quoteDetails.splice(this.quote.quoteDetails.indexOf(quote), 1);
    }

    selectQuote(quote: IAirQuoteDetails): void {
        this.quote.quoteDetails.forEach(function (element) {
            element.selected = false;
        });
        quote.selected = true;

        // Determine the Approving Manager        
        if (this.quote.formStatusId != QuoteStatuses.WaitingManagerApproval) {
            this.quoteHistoryService.getApprovingManager(this.quote.id, quote.id).subscribe((result: IAirQuoteApproverModel): void => {
                if (result) {
                    this.quote.quoteApproverID = result.id;
                }
                else {
                    this.toast.error("There was an error getting the approving manager. Please contact support.", "Error", { toastLife: 10000 });
                }
            });
        }
    }

    submitPurchaseForm(isSave: boolean): void {
        this.submitting = true;

        this.quoteFormGroup.updateValueAndValidity();

        if (!this.quoteFormGroup.valid)
            return;

        this.quote.items = this.items;        

        this.quote.reasonCode = this.selectedReason.id;   
        this.quote.shipLocationId = this.selectedShipLocation.id;
        
        if (this.quoteId > 0) {

            var status = this.quote.formStatusId;            
            if (status == QuoteStatuses.TeamObtainingQuotes && this.quote.quoteDetails.length == 0) {
                this.toast.error("There was an error updating the request. Quotes need to be entered.", "Error", { toastLife: 10000 });
                return;
            }

            if (status == QuoteStatuses.TeamObtainingQuotes) {
                this.quote.formStatusId = QuoteStatuses.SelectQuote;
            }
            else if (this.quote.formStatusId == QuoteStatuses.SelectQuote) {                
                if (this.quote.quoteApproverID === undefined) {                    
                    this.toast.error("There was an error updating the request. The quote was not selected. Please contact support.", "Error", { toastLife: 10000 });
                    return;
                }
                else {
                    this.quote.formStatusId = QuoteStatuses.WaitingManagerApproval;
                }
            }
            else if (this.quote.formStatusId == QuoteStatuses.WaitingTrackingInformation)
                this.quote.formStatusId = QuoteStatuses.Completed;           

            this.quoteFormService.updateQuote(this.quote).subscribe((result: IAirQuoteModel): void => {
                // Use this to handle attachments
                if (result) {  
                    this.processAttachments(result);

                    if (status == QuoteStatuses.TeamObtainingQuotes) {
                        this.toast.success("Shipping quotes have been added to the request.", "Success", { toastLife: 10000 });
                        this.router.navigate(["airTraffic"]);
                    }
                    else if (status == QuoteStatuses.SelectQuote) {
                        this.toast.success("Shipping quote has been selected. Request is now pending manager approval.", "Success", { toastLife: 10000 });
                        this.router.navigate(["airQuoteHistory"]);
                    }
                    else if (status == QuoteStatuses.WaitingTrackingInformation) {
                        this.toast.success("Tracking information has been added. ", "Success", { toastLife: 10000 });
                        this.router.navigate(["airQuoteHistory"]);
                    }
                    else {
                        this.toast.success("Quote was successfully updated. ", "Success", { toastLife: 10000 });
                        this.router.navigate(["airQuoteHistory"]);
                    }
                }
                else {
                    this.quote.formStatusId = status;
                    this.toast.error("There was an error updating the request. Please contact support.", "Error", { toastLife: 10000 });
                }
            });
            
        } else {

            this.quote.username = this.constants.user.username;
            this.quote.lastName = this.constants.user.lastName;
            this.quote.firstName = this.constants.user.firstName;

            if (!isSave) {                
                this.quoteFormService.addPurchaseForm(this.quote).subscribe((result: IAirQuoteModel): void => {
                    // Use this to handle attachments and uploads
                    if (result) {
                        this.toast.success("Quote request has been accepted and is waiting for traffic team review.", "Success", { toastLife: 10000 });
                        this.processAttachments(result);
                        this.router.navigate(["airQuoteHistory"]);
                    } else {
                        this.toast.error("There was an error adding your quote. Please contact support.", "Error", { toastLife: 10000 });
                    }
                });
            } else {                
                this.quoteFormService.savePurchaseForm(this.quote).subscribe((result: IAirQuoteModel): void => {
                    // Use this to handle attachments and uploads
                    if (result) {
                        this.toast.success("Quote has been saved.", "Success", { toastLife: 10000 });
                        this.processAttachments(result);
                        this.router.navigate(["airQuoteHistory"]);
                    } else {
                        this.toast.error("There was an error saving your quote. Please contact support.", "Error", { toastLife: 10000 });
                    }
                });
            }
        }
    }

    onReasonCodeSelect() {            
        if (!this.selectedReason)
            return;
        this.reasonCode = this.selectedReason.reasonCode;        
    }

    onShipLocationCodeSelect() {

        if (!this.selectedShipLocation)
            return;
        this.shipLocation = this.selectedShipLocation.id;

        this.shipStreet = this.selectedShipLocation.street;
        this.shipCity = this.selectedShipLocation.city;
        this.shipState = this.selectedShipLocation.state;
        this.shipZipcode = this.selectedShipLocation.zipcode;       
    }

    onShippingMethodCodeSelect() {
        if (!this.selectedShipMethod)
            return;
    }

    checkGreaterThanZero(c: FormControl) {
        return !isNaN(c.value) && c.value > 0 ? null : { notValidNumber: { valid: false, message: "Please enter a number greater than zero" } };
    }

    checkItems = () => {
        return (this.items.length > 0) ? null : { noItems: { valid: false, message: "No items added." } };
    }

    validateDate(c: FormControl) {
        let dateReg = /^\d{1,2}([./-])\d{1,2}\1\d{4}$/;
        let d = new Date(c.value);
        d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
        let date = `${(d.getMonth() + 1)}/${d.getDate()}/${d.getFullYear()}`;
        let match = date.toString().match(dateReg);
        let currentutureDate = Date.parse(date) >= Date.parse(new Date().toDateString());

        return match && currentutureDate ? null : { notValidDate: { valid: false, message: "Invalid Date." } };
    }
    isSubmitDisabled(): boolean {
        var valid = this.quoteFormGroup.valid && !this.submitting;

        return !valid;
    }

    updateApprovalStatus(quote: IAirQuoteModel, toFormStatusId: number, username: string): void {
        this.quoteFormService.updateQuoteStatus(quote.id, toFormStatusId, username).subscribe((result: boolean): void => {
            if (result) {
                this.toast.success(`Quote ${quote.id} has been updated.`, "Success", { toastLife: 5000 });
            } else
                this.toast.error("Error updating the status of the quote.", "Error", { toastLife: 10000 });
        });
    }

    addAttachments(input: HTMLInputElement): void {
        //input.value = "" is to ensure that you can add a file of the same name after you delete it. If you dont do this you will delete it and you cannot add it again until you add another file with a different name.
        if (input.files.length > 0) {

            for (let i = 0; i < input.files.length; i++) {
                let checkAttachment = this.quote.attachments.find((attachment: IAttachmentModal) => {
                    return attachment.name === input.files[i].name;
                });

                if (checkAttachment) {
                    this.toast.error("Cannot add a file that has the same name.", "Duplicate Filename", { toastLife: 10000 });
                    input.value = "";
                    return;
                }

                let attachmentToAdd = <IAttachmentModal>{
                    id: 0,
                    formId: this.quote.id,
                    formTypeId: FormType.TrafficTeam,
                    name: input.files[i].name
                };

                this.quote.attachments.push(attachmentToAdd);
                this.attachments.push(input.files[i]);
            }

            input.value = "";
            this.toast.success("Attachment(s) added", "Success", { toastLife: 5000 });
        }
    }

    removeAttachment(attachment: IAttachmentModal): void {
        if (this.quote.attachments.length > 0) {

            if (attachment.id > 0) {
                this.quoteFormService.removeAttachment(attachment).subscribe((deleted: boolean): void => {
                    if (deleted)
                        this.removeAttchmentFromQuote(attachment);
                });
            } else
                this.removeAttchmentFromQuote(attachment);
        }
    }

    removeAttchmentFromQuote(attachment: IAttachmentModal): void {
        let approvalIndex = this.quote.attachments.indexOf(attachment);

        if (approvalIndex > -1)
            this.quote.attachments.splice(approvalIndex, 1);

        let attach = this.attachments.find((file: File) => {
            return file.name === attachment.name;
        });

        let fileIndex = this.attachments.indexOf(attach);

        if (fileIndex > -1)
            this.attachments.splice(fileIndex, 1);

        this.toast.success("Attachment has been deleted.", "Delete Attachment", { toastLife: 10000 });
    }

    processAttachments(quote: IAirQuoteModel) {
        if (quote) {
            if (this.attachments.length > 0) {
                this.quoteFormService.uploadAttachments(this.attachments, quote.id, FormType.TrafficTeam).subscribe((attachmentResult: any): void => {
                    if (attachmentResult) {
                        this.toast.success("Attachment(s) added", "Success", { toastLife: 10000 });
                    } else
                        this.toast.error("There was an error adding your attachments. Please contact support.", "Error", { toastLife: 10000 });
                });
            }
        }
        else
            this.toast.error("There was an error submitting your request. Please contact support.", "Error", { toastLife: 10000 });
    }

    addComment(shippingType: string) {   
        var preFix = "Please obtain quotes for the following: ";

        if (this.quote.comment === undefined)
            this.quote.comment = '';

        if (!this.quote.comment.includes(preFix))
            this.quote.comment += preFix;

        if (this.quote.comment.includes(shippingType)) {            
            this.quote.comment = this.quote.comment.replace(shippingType, '');
        }
        else
            this.quote.comment += shippingType;
    }
}